"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Dynamic = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _useSfraApi = _interopRequireDefault(require("../../hooks/useSfraApi"));
const _excluded = ["component", "className", "index"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
const Dynamic = _ref => {
  let {
      component,
      className,
      index
    } = _ref,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  const {
    pages
  } = (0, _useSfraApi.default)();
  const componentMapping = pages === null || pages === void 0 ? void 0 : pages.getComponentMapping();
  if (componentMapping && typeof componentMapping[component.type_id] !== 'undefined') {
    return /*#__PURE__*/_react.default.createElement(componentMapping[component.type_id], _objectSpread({
      data: component.data,
      regions: component.regions,
      custom: component.custom,
      index,
      className: component.className || '',
      componentID: component.id
    }, rest));
  }
  return /*#__PURE__*/_react.default.createElement(() => /*#__PURE__*/_react.default.createElement("div", null, "The component ", component.type_id, " has not been created yet."));
};
exports.Dynamic = Dynamic;